import React from 'react';
import cx from 'classnames';
import './index.css';
import {FormattedMessage} from "react-intl";

export default ({large, link}) => {
    const classes = cx({
        'buy-now-button': true,
        'buy-now-button--large': large
    });
    return (
        <a
            className={classes}
            target="_blank"
            href={link}
        >
            <FormattedMessage id="button.buy.now.text" />
        </a>
    );
}
